<div class="layout-column custom-panel full-height">
  <div class="layout-row layout-align-start-center header">
    <span class="br-body-2 font-weight-600 primary-100" translate>Edit Service Time</span>
    <span class="flex"></span>
    <bringoz-button type="tertiary"
                    (onClick)="onClose.emit()">
      <bringoz-icon iconName="close" class="secondary-100"></bringoz-icon>
    </bringoz-button>
  </div>
  <hr class="main-divider">
  <div class="layout-column flex">
    <div class="table-head layout-row layout-align-start-center">
      <span class="br-body-2 font-weight-400 flex-40 padding-10" translate>Type</span>
      <span class="br-body-2 font-weight-400 flex padding-10" translate>Current</span>
      <span class="br-body-2 font-weight-400 flex padding-10" translate>New</span>
    </div>

    <div class="layout-column flex">
      <div class="layout-row layout-align-start-center">
        <span class="br-body-2 font-weight-400 flex-40 padding-10" translate>Entry Time</span>
        <span
          class="br-body-2 font-weight-400 flex padding-10">{{ detailedServiceTime.entryTime | serviceTime }}</span>
        <app-bringoz-service-time-input class="flex padding-10"
                                        [serviceTime]="detailedServiceTimeCopy.entryTime"
                                        (onChange)="onChangeValue($event, 'entryTime')">

        </app-bringoz-service-time-input>
      </div>
      <hr class="main-divider">

      <div class="layout-row layout-align-start-center">
        <span class="br-body-2 font-weight-400 flex-40 padding-10" translate>Exit Time</span>
        <span
          class="br-body-2 font-weight-400 flex padding-10">{{ detailedServiceTime.exitTime | serviceTime }}</span>
        <app-bringoz-service-time-input class="flex padding-10"
                                        [serviceTime]="detailedServiceTimeCopy.exitTime"
                                        (onChange)="onChangeValue($event, 'exitTime')">

        </app-bringoz-service-time-input>
      </div>
      <hr class="main-divider">

      <div class="layout-row layout-align-start-center">
        <span class="br-body-2 font-weight-400 flex-40 padding-10" translate>Work Time</span>
        <span
          class="br-body-2 font-weight-400 flex padding-10">{{ detailedServiceTime.workTime | serviceTime }}</span>
        <app-bringoz-service-time-input class="flex padding-10"
                                        [serviceTime]="detailedServiceTimeCopy.workTime"
                                        (onChange)="onChangeValue($event, 'workTime')">

        </app-bringoz-service-time-input>
      </div>
      <hr class="main-divider">

      <div class="layout-row layout-align-start-center">
        <span class="br-body-2 font-weight-400 flex-40 padding-10" translate>Packages</span>
        <span
          class="br-body-2 font-weight-400 flex padding-10">{{ detailedServiceTime.packagesTime | serviceTime }}</span>
        <app-bringoz-service-time-input class="flex padding-10"
                                        [serviceTime]="detailedServiceTimeCopy.packagesTime"
                                        [isDisabled]="true">

        </app-bringoz-service-time-input>
      </div>
      <hr class="main-divider">

      <div class="layout-row layout-align-start-center">
        <span class="br-body-2 font-weight-600 flex-40 padding-10" translate>Total</span>
        <span class="br-body-2 font-weight-400 flex padding-10"></span>
        <span class="br-body-2 font-weight-400 flex padding-10">
          {{ ((detailedServiceTimeCopy.packagesTime || 0) + (detailedServiceTimeCopy.workTime) + (detailedServiceTimeCopy.entryTime || 0) + (detailedServiceTimeCopy.exitTime || 0)) | serviceTime }}</span>
      </div>
    </div>
  </div>

  <hr class="main-divider">
  <div class="layout-row layout-align-start-center padding-10">
    <bringoz-button type="tertiary"
                    (onClick)="onClose.emit()">
      <span translate>Cancel</span>
    </bringoz-button>
    <span class="flex"></span>
    <bringoz-button (onClick)="onReset()"
                    class="margin-right-5"
                    type="outline"
                    theme="secondary">
      <span translate>Reset</span>
    </bringoz-button>

    <bringoz-button (onClick)="onSubmit()"
                    theme="secondary">
      <span translate>Confirm</span>
    </bringoz-button>

  </div>
</div>
